module.exports = __webpack_public_path__ + "img/top-qiwei-code.be2662b.png";